import * as React from 'react';
import './EtjanstHeader.global.css';
import {Col, Row} from 'react-bootstrap';
import {ContentNavigator} from './ContentNavigator';
import {Card} from "reactstrap";
import Logo from 'mig-svg-icons/lib/Icon/Logo';

export const EtjanstHeader = () => {
    return (
        <header className={"headerBorder"}>
            <ContentNavigator/>
            <Card>
                <div className={"container"}>
                    <Row className="etjanstHeader m-0">
                        <Col className="d-flex align-items-center mt-3 mb-3">
                            <Logo className='x10' />
                        </Col>
                    </Row>
                </div>
            </Card>
        </header>
    )
}
